<div class="o-navbar">
  <div class="wrapper">
    <div class="left">
      <img src="./assets/logo-sped.jpg" alt="logo-sped" class="logo">
    </div>
    <div class="right">
      <div class="o-links">
        <div class="o-link non-clickable dropdown" *ngIf="(shouldShowSuperiorButtons)">
          Dashboard
          <i class="material-icons  non-clickable">keyboard_arrow_down</i>
          <dl class="drop-menu">
              <a [routerLink]="['/main/dashboard/management-panel']" class="item-sub">Dashboard</a>
              <a (click)="navigateToEditorApp()" class="item-sub" target="_blank" rel="noopener noreferrer">Edição de Arquivos Fiscais</a>
          </dl>
        </div>
        <div class="o-link clickable" *ngIf="(shouldShowSuperiorButtons)" [routerLink]="['/main/notification-center']">
          Central de Notificações</div>
        <div class="o-link non-clickable dropdown" *ngIf="(shouldShowSuperiorButtons)">
          Relatórios
          <i class="material-icons  non-clickable">keyboard_arrow_down</i>
          <dl class="drop-menu">
            <dt class="tittle-item">Gerencial</dt>
              <a [routerLink]="['/main/reports/product-usage']" class="item-sub">Utilização do Produto</a>
              <a [routerLink]="['/main/reports/processing-evolution']" class="item-sub">Evolução dos Processamentos</a>
              <a [routerLink]="['/main/reports/license-usage']" class="item-sub">Utilização das Licenças</a>
            <dt class="tittle-item">Operacional</dt>
              <a [routerLink]="['/main/reports/relatorio-gestao']" class="item-sub">Relatório Geral das Operações</a>
          </dl>
        </div>
        <div class="o-link non-clickable dropdown" *ngIf="(shouldShowSuperiorButtons)">
          Configurações
          <i class="material-icons non-clickable">keyboard_arrow_down</i>
          <ul class="drop-menu">
            <a [routerLink]="['/main/settings/digital-certificate']" class="item">Certificado Digital</a>
            <a [routerLink]="['/main/settings/accountant-registration']" class="item">Cadastro do Contador (Usuários da plataforma)</a>
            <a [routerLink]="['/main/settings/companies-obligations']" class="item">Cadastro de Empresas e Obrigações</a>
            <a *ngIf="hasPermissionBulkUpdates" [routerLink]="['/main/settings/bulk-updates']" class="item">Manutenções em Lote</a>
            <a [routerLink]="['/main/settings/uploader/download']" class="item">Download do Uploader</a>
          </ul>
        </div>
        <div class="o-link avatar dropdown non-clickable">
          <i class="material-icons o-icon -medium -mRight">account_circle</i>
          Olá, {{grettingName}}
          <ul class="drop-menu -right">
            <a class="item clickable" (click)="alterarSenha()">Alterar minha senha</a>
            <a class="item clickable" [href]="urlBlobPdf" target="_blank">FAQ - Perguntas Frequentes</a>
            <a appLogout class="item clickable">Sair</a>
          </ul>
          <i class="material-icons non-clickable">keyboard_arrow_down</i>
        </div>
      </div>
    </div>
  </div>
</div>
